module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABGSURBVHgB7dCxEQAQFATRO5FQKFSSCvSgEx1oQSfKkKrApwUjMGO8fJOl9dlRVBXAYAPJ2EpISgN9xR27hji8gX/iufsTJzwBJBb4XRo5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ham.png
// module id = gSNM
// module chunks = 1